export default "New and exciting things have arrived.";